<!-- 注册审批管理-列表首页 -->
<template>
  <div id="accountManage" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">一级用户注册审批</div>
    <!-- 头部标题&按钮 -->
    <div class="header flexBetween">
      <div class="btns_tab">
        <div @click="changeTable(1)" :class="type_table==1?'active':''">待审批</div>
        <div @click="changeTable(2)" :class="type_table==2?'active':''">已通过</div>
        <div @click="changeTable(3)" :class="type_table==3?'active':''">已驳回</div>
      </div>
      <div class="btns_table">
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryParam.keyWords" size="small" clearable @change="getTableData"
          @keyup.enter.native="getTableData" style="margin-left:10px"></el-input>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table" @sort-change="handleSortChange" @row-click="rowClick"
        :default-sort="type_table!=3?{prop: 'openTime', order: 'descending'}:{prop: 'tenderTime', order: 'descending'}">
        <el-table-column prop="number" label="序号" width="60">
          <template slot-scope="props">
            <span>{{((queryParam.page-1)*queryParam.limit)+Number(props.$index+1)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item,i) in tableKeys_current" :key="i" :prop="item.key" :label="item.title" :sortable="item.sortable?'custom':false"
          show-overflow-tooltip align="center" :min-width="item.width??''">
          <template slot-scope="props">
            <div v-if="item.type=='status'" :class="item.class_status[props.row[item.key]]" class="nowrap">
              {{item.text_status[props.row[item.key]]?item.text_status[props.row[item.key]]:'--'}}</div>
            <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}`}}</div>
            <div v-else-if="item.type=='time'" class="nowrap">{{ props.row[item.key]?moment(props.row[item.key]).format('YYYY-MM-DD'):'--'}}</div>
            <el-button v-else-if="item.type=='btn'" type="text" @click="item.opt">{{ item.title}}</el-button>
            <div v-else class="nowrap">{{props.row[item.key]?props.row[item.key]:'---'}}</div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" min-width="150" align="center">
          <template #default="scope">
            <el-button type="text" @click.stop="rowClick(scope.row)">详情</el-button>
            <el-button v-if="type_table==1" type="text" @click.stop="approveRow(scope.row,1)">通过</el-button>
            <el-button v-if="type_table==1" type="text" @click.stop="approveRow(scope.row,0)">驳回</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <img src="../../../assets/img/emptyData.png" alt="">
        </div>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <div v-show="InnerWH.width>450">共{{total}}条数据</div>
      <el-pagination hide-on-single-page background @current-change="handleCurrentChange" :current-page.sync="queryParam.page" :page-size="10" :pager-count="5"
        :layout="InnerWH.width>450?'prev, pager, next, jumper':'prev, pager, next'" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: "accountManage",
  data() {
    return {
      moment: moment,
      // 列表查询传参
      queryParam: {
        keyWords: "",
        page: 1,
        limit: 10,
      },
      // 列表类型（1参与投标；2已中标；3开标一览表）
      type_table: Number(this.$route.query.type_table) || 1,
      // 列表字段合集
      tableKeys_current: [
        { title: "企业名称", key: "enterprieName", width: 150 },
        { title: "注册时间", key: "createTime", type: 'time', width: 110, sortable: true },
        { title: "目前所涉及的行业", key: "category", width: 150 },
        { title: "企业法人", key: "enterpriseLegalPerson", width: 150 },
        { title: "企业联系人", key: "enterprieContacts", width: 150 },
        { title: "企业邮箱", key: "enterprieMail", width: 150 },
        { title: "审批状态", key: "approvalStatus", type: 'status', text_status: ['', '待审批', '已通过', '已驳回'], class_status: ['', 'orange', 'green', 'red'], width: 160 },
      ],
      // 列表数据(参与投标)
      tableData: [],
      total: 0,
    };
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  mounted() {
    this.changeTable(this.type_table);
  },
  methods: {
    //获取列表数据
    getTableData() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/approveList`, this.queryParam).then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.page.list;
            this.total = res.data.page.totalCount;
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 列表字段初始化
    changeTable(type) {
      this.type_table = type;
      this.$set(this.queryParam, 'approvalStatus', this.type_table);
      if (type == 1 || type == 2) {
        this.handleSortChange({ prop: 'openTime', order: 'descending' });
      } else {
        this.handleSortChange({ prop: 'tenderTime', order: 'descending' });
      }
    },
    // 列表-排序
    handleSortChange(column) {
      let sortParam = ['name'];
      let tableParam = ['projectName'];
      // 清空参数
      sortParam.forEach((p) => {
        this.$delete(this.queryParam, p);
      })
      // 放置排序参数
      // if (column.order) {
      //   let order = 1;
      //   if (column.order == "descending") { order = 2 }
      //   this.$set(this.queryParam, sortParam[tableParam.indexOf(column.prop)], order);
      // }
      // 刷新列表
      this.queryParam.page = 1;
      this.getTableData();
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getTableData();
    },
    // 详情
    rowClick(item) {
      this.$router.push({
        path: "/accountPages/detail_accountManage",
        query: { id: item.id }
      })
    },
    // 审批
    approveRow(item, result) {
      this.$msgbox({
        title: result == 1 ? '通过' : '驳回',
        message: `是否确定${result == 1 ? '通过' : '驳回'}该用户？`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/user/approve`, { id: item.id, approvalStatus: result == 1 ? 2 : 3 }).then(res => {
                if (res.data.code == 200) {
                  let totalPage = Math.ceil((that.total - 1) / that.queryParam.limit);
                  let current = that.queryParam.page > totalPage ? totalPage : that.queryParam.page;
                  that.queryParam.page = current < 1 ? 1 : current;
                  that.getTableData();
                  that.$message({
                    message: "操作成功",
                    type: "success"
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              }).catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).then(action => {
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
          offset: 100
        });
      })
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == "ascending" || header.column.order == "descending") {
        return { color: "#3D7BDC", fontSize: "14px", fontWeight: 400 };
      } else {
        return { color: "#617180", fontSize: "14px", fontWeight: 400 };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: "14px",
        color: "#111928",
        fontWeight: 500,
        padding: "8px 0px",
      };
    },
  }
};
</script>
<style lang="less" scoped>
.btns_tab {
  width: 320px;
  display: flex;
  margin-top: 23px;
  margin-bottom: 17px;
  padding: 4px;
  font-weight: 500;
  border-radius: var(--rounded-md, 6px);
  border: 1px solid rgba(229, 231, 235, 0.8);
  background: var(--gray-100, #f3f4f6);
  div {
    width: 50%;
    text-align: center;
    cursor: pointer;
    line-height: 150%;
    padding: 4px;
  }
  .active {
    border-radius: var(--rounded-md, 6px);
    background: var(--gray-700, #374151);
    color: #ffffff;
  }
}
.absoluteGrop {
  z-index: 10;
}
</style> 